import { useQuery } from '@tanstack/react-query';

import { SEARCH_WIDGET_TYPES } from 'constants/ProjectConstants';

import { getFeedbackDetailsById } from 'services/continuousFeedback';
import { tagAutocomplete } from 'services/search';

import { REACT_QUERY_FEEDBACK_DRAWER_KEYS } from '../constants';

export const useApplicableCompetenciesQuery = ({ mentionedEmployeeIds = [] }) =>
  useQuery([REACT_QUERY_FEEDBACK_DRAWER_KEYS.applicableCompetencies, mentionedEmployeeIds], () =>
    tagAutocomplete({
      query: '',
      teamId: null,
      widgetType: SEARCH_WIDGET_TYPES.post,
      employeeIds: mentionedEmployeeIds,
    })
  );

export const useFillRequestedFeedbackQuery = ({ feedbackId }: { feedbackId: string }) =>
  useQuery(
    [REACT_QUERY_FEEDBACK_DRAWER_KEYS.fillRequestedFeedback, feedbackId],
    () => {
      console.log('feedbackId', feedbackId);
      return getFeedbackDetailsById({
        feedbackId,
      });
    },
    {
      enabled: Boolean(feedbackId),
    }
  );
